import React, { Component } from 'react';
import { Clearfix, Button } from 'react-bootstrap';
import FieldGroup from '../../../../components/FieldGroup';
import Icon from '../../../../components/Icon';
import { handleFieldChange } from "../../../../Utils";
import SelectWrap from "../../../../components/SelectWrap";
import countriesObj from "../../../../data/countries";


class PercentageForm extends Component {
    constructor(props) {
        super(props);

        this.state = { percentage: props.percentage };


        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

    }

    handleSubmit(event) {
        event.preventDefault();
        this.props.onSubmit(this.state.percentage);
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div style={{ display: 'flex', width: '100%', alignItems: 'center' }}>
                    <div style={{ width: '80%'}}>
                        <FieldGroup
                            name="percentage"
                            type="number"
                            min={0}
                            max={100}
                            label="Percentage:"
                            onChange={this.handleFieldChange}
                            value={this.state.percentage || this.state.percentage === 0 ? this.state.percentage : this.props.percentage}
                            required
                        />
                    </div>
                    <Button style={{ height: 'auto', marginLeft: 'auto'}} bsStyle="success" type="submit"><Icon name="floppy-o"/> Save</Button>
                </div>
            </form>
        );
    }
}

export default PercentageForm;


// WEBPACK FOOTER //
// ./src/scenes/Dating/components/PercentageForm/index.js